const DPONET_ORGANIZATION_ID = 1
const CS_ORGANIZATION_ID = 2

const DPO_KIND = 'DPO'
const OBSERVER_KIND = 'OBSERVER'
const CUSTOMER_SUCCESS_KIND = 'CUSTOMER_SUCCESS'

const KINDS = {
  ALL_SORTS: '',
  [DPO_KIND]: 'DPO',
  [OBSERVER_KIND]: 'OBSERVER',
  [CUSTOMER_SUCCESS_KIND]: 'CUSTOMER_SUCCESS',
}

const KIND_LABEL = {
  [DPO_KIND]: 'DPO',
  [OBSERVER_KIND]: 'Observador',
  [CUSTOMER_SUCCESS_KIND]: 'Sucesso do Cliente',
}

const REAL_ORGANIZATION_KINDS = [
  { id: DPO_KIND, name: 'DPO' },
  { id: OBSERVER_KIND, name: 'Observador' },
]

const STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

const TABS = [
  {
    value: KINDS.ALL_SORTS,
    label: 'Todas',
  },
  {
    value: KINDS.DPO,
    label: 'DPO',
  },
  {
    value: KINDS.OBSERVER,
    label: 'Observador',
  },
  {
    value: KINDS.CUSTOMER_SUCCESS,
    label: 'Sucesso do Cliente',
  },
]

const JURIDIC_KIND = 'juridic'

const GOVERNANCE_PROJECTS_ARCHIVE_WARNING =
  'Os projetos de governança vinculados a essa empresa serão arquivados devido à perda de vínculo com o template.'

const organizations = {
  CS_ORGANIZATION_ID,
  CUSTOMER_SUCCESS_KIND,
  DPO_KIND,
  DPONET_ORGANIZATION_ID,
  GOVERNANCE_PROJECTS_ARCHIVE_WARNING,
  JURIDIC_KIND,
  KINDS,
  KIND_LABEL,
  OBSERVER_KIND,
  REAL_ORGANIZATION_KINDS,
  STATUSES,
  TABS,
}

export default organizations
